<div class="header-container">
    <div id="bloc1" class="block1" >
        <span >
            	<mat-icon> business</mat-icon>
        </span>
        <span class="hide-text-lebel">
          Company
        </span>
    </div>
    <div id="bloc2" class="block2">
      <input class="search-bar" 
      type="search" 
      aria-label="search" 
      placeholder="Search" 
      [(ngModel)]="searchText"  
      (ngModelChange)="onSearch($event)"> 
    </div>
    <div id="bloc3" class="block3">
      <span class="full-text">
        <button (click)= "openDialog(blankCompanyData)" mat-raised-button>Add Company</button>
    </span>
    <span class="short-text">
      <button (click)= "openDialog(blankCompanyData)" mat-raised-button>Create</button>
    </span>
    </div>
    
</div>
<!-- <mat-spinner style="margin: auto;" *ngIf="showSpinner; else showContent" ></mat-spinner>

<ng-template #showContent>
  <div style="padding: 3vw;">
    <table class="table table-striped table-hover" data-row-style="rowStyle">
        <thead>
          <tr class="t-header">
            <th class="" scope="col">
              <div  class="actionPadding" title="Name">Company Name</div>
            </th>
            <th class="" scope="col">
              <div title="Country">Country</div>
            </th>
            <th class="" scope="col">
              <div title="CountryCode ">Country Code </div>
            </th>
            <th class="" scope="col">
              <div title="BranchCode">Branch Code</div>
            </th>
            <th class="" scope="col">
              <div title="Add">Add Number</div>
            </th>
            <th class="" scope="col">
              <div title="Edit">Edit</div>
            </th>
            <th class="" scope="col">
            <div title="Delete">Delete</div>
            </th>
          </tr>
        </thead>
        <tbody>
            <tr *ngFor="let data of filteredCompanyList let indexOfelement=index;">
                <td>
                  {{data.name | titlecase}}
                </td>
                <td>
                  {{data.country | titlecase}}
                </td>
                <td>
                  {{data.country_code}}
                </td>
                <td>
                  {{data.branch_code}}
                </td>
                <td>
                  <mat-icon (click)= "openAddNumberDialog(data)">add</mat-icon>
                </td>
                <td>
                  <mat-icon (click)= "openDialog(data)">create</mat-icon>
                </td>
                <td>
                  <mat-icon (click) = "deleteCompany(data)">delete</mat-icon>
                </td>
            </tr>
        </tbody>
    </table>
  </div>
</ng-template> -->

<mat-spinner style="margin: auto;" *ngIf="showSpinner" ></mat-spinner>

<div class="mat-elevation-z8" style="padding: 2vw;" [hidden]="showSpinner">
    <table mat-table [dataSource]="dataSource">
    
        <ng-container matColumnDef="name">
          <th mat-header-cell *matHeaderCellDef> Company Name </th>
          <td mat-cell *matCellDef="let row"> {{row.name | titlecase}} </td>
        </ng-container>

        <ng-container matColumnDef="country">
          <th mat-header-cell *matHeaderCellDef> Country </th>
          <td mat-cell *matCellDef="let row" > {{row.country | titlecase}} </td>
        </ng-container>

        <ng-container matColumnDef="country_code">
          <th mat-header-cell *matHeaderCellDef> Country Code </th>
          <td mat-cell *matCellDef="let row" > {{row.country_code}} </td>
        </ng-container>

        <ng-container matColumnDef="branch_code">
          <th mat-header-cell *matHeaderCellDef> Branch Code </th>
          <td mat-cell *matCellDef="let row" > {{row.branch_code}} </td>
        </ng-container>
    
        <ng-container matColumnDef="id">
          <th mat-header-cell *matHeaderCellDef> Phone </th>
          <td mat-cell *matCellDef="let row" > <mat-icon (click)= "openAddNumberDialog(row)">add</mat-icon> </td>
        </ng-container>

        <ng-container matColumnDef="updated_at">
          <th mat-header-cell *matHeaderCellDef> Edit </th>
          <td mat-cell *matCellDef="let row" > <mat-icon (click)= "openDialog(row)">create</mat-icon> </td>
        </ng-container>
    
        <ng-container matColumnDef="created_at" >
          <th mat-header-cell *matHeaderCellDef> Delete </th>
          <td mat-cell *matCellDef="let row"> <mat-icon (click) = "deleteCompany(row)">delete</mat-icon> </td>
        </ng-container>
    
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

        <tr class="mat-row" *matNoDataRow>
        <td class="mat-cell" colspan="4">No data matching the filter "{{searchText}}"</td>
        </tr>
    </table>
    
    <mat-paginator [pageSizeOptions]="[10, 20, 30]" showFirstLastButtons></mat-paginator>
</div>

